(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scenthaus-scent-guide"] && !Shopify.designMode) return;
  try {
    
function initScentGuide(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const cards = Array.from(root.querySelectorAll('[data-category]'));
  const buttons = Array.from(root.querySelectorAll('[data-filter]'));
  const search = root.querySelector('input[type="search"]');
  let category = 'all';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const update = () => {
    const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    let count = 0;
    cards.forEach(card => {
      const matches = (category === 'all' || card.dataset.category === category) && words.every(word => normalize(card.dataset.search).includes(word));
      card.hidden = !matches;
      if (matches) count++;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
    root.querySelector('[data-count]').textContent = count;
    root.querySelector('.sh-guide__empty').hidden = count !== 0;
  };
  buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.filter; update(); }));
  search.addEventListener('input', update);
  root.querySelector('[data-reset]').addEventListener('click', () => { category = 'all'; search.value = ''; update(); search.focus(); });
  root.querySelector('.sh-guide__tools').hidden = false;
  update();
}
document.querySelectorAll('.sh-guide').forEach(initScentGuide);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sh-guide').forEach(initScentGuide));

  } catch(e) { console.error(e); }
})();
})();
